import React from 'react'

import StoryItemCard from './StoryItemCard'


export default class extends React.Component{

  constructor(props)
  {
    super(props);
    this.state = {
      isSelected: this.props.item.isSelected,
      position:this.props.item.position
    }
  }

  componentDidMount() {
    this.timer = setInterval(() => {
      if (this.props.item.isSelected != this.state.isSelected)
      {
        this.state.isSelected = this.props.item.isSelected;
        this.forceUpdate();
      }
    }, 200)
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  render()
  {
    var {
      item,
      onSelect,
      onShiftUp,
      onShiftDown,
      onRemove,
      onShiftAlign,
      onShiftOrder,
      onChangeItem,
      index,
    } = this.props;
    //console.log(item);

  var TextFontSize = '14pt';
  var TextFontWeight = 'normal';
if (this.props.item.text){
    switch (this.props.item.text._attributes.size){
      case 'small':
        TextFontSize = '12pt';
        break
      case 'xlarge':
        TextFontSize = '24pt';
        break;
      case 'large':
        TextFontSize = '18pt';
        break;     
    }    
    switch (this.props.item.text._attributes.style){
      case 'light':
        TextFontWeight = 'lighter';
      break;
      case 'regular':
        TextFontWeight = 'normal';
      break;     
      case 'bold':
        TextFontWeight = 'bold';
      break;     
    }
}

  var NameFontSize = '14pt';
  var NameFontWeight = 'normal';

if (this.props.item.name){
  switch (this.props.item.name._attributes.size){
    case 'small':
      NameFontSize = '12pt';
      break
    case 'xlarge':
      NameFontSize = '24pt';
      break;
    case 'large':
      NameFontSize = '18pt';
      break;       
  }
  var NameFontWeight = 'normal';
  switch (this.props.item.name._attributes.style){
    case 'light':
      NameFontWeight = 'lighter';
    break;
    case 'regular':
      NameFontWeight = 'normal';
    break;     
    case 'bold':
      NameFontWeight = 'bold';
    break;     
  }
}
    


    
   
    return (
        <StoryItemCard
            index={this.props.index}            
            item={this.props.item}
            isSelected={this.state.isSelected}
            isAllowEdit={item.type === 'Text' || item.type === 'Media' || item.type === 'Narrative'}
            onShiftUp={() => {
              onShiftUp && onShiftUp(item);
            }}
            onShiftDown={() => {
              onShiftDown && onShiftDown(item);
            }}
            onSelect={() => {
              onSelect && onSelect(item);
              this.forceUpdate();
            }}
            onRemove={() => {
              onRemove && onRemove(item);
              this.forceUpdate();
            }}
            onShiftAlign={() => {
              onShiftAlign && onShiftAlign(item);
              this.forceUpdate();
            }}
            onShiftOrder={() => {
              onShiftOrder && onShiftOrder(item);
              this.forceUpdate();
            }}
            onChangeItem={() => {
              onChangeItem && onChangeItem();              
            }}
        >  #{index}

        {((item.type === 'Text' || item.type === 'Narrative') && item.bg.enabled)?
          (
            <span style={{color:'#ff0000'}}>
              &nbsp; 有背景
            </span>
          )
        :null}

          {(item.type === 'Text' || item.type === 'Media') && item.name.enabled==true ?(
            <div style={{color:item.name._attributes.color,maxWidth:`100%`,width:`auto`,borderRadius: `14px`,padding: `8px`,marginRop: `20px`,fontSize:NameFontSize,fontWeight:NameFontWeight}}>
              {item.name._text}
            </div>
          ):null}

          {(item.type === 'Media')?(
            <div style={{width: `260px`,  height: `260px`,backgroundRepeat: `no-repeat`,backgroundSize: `cover`,backgroundPosition: `50% 50%`,borderRadius: `8px`,backgroundImage:`url(`+item.media._attributes.base64_data+`)`,display:`inline-block`, border:`3px solid`,borderColor:item._attributes.itemColor}}>
              
            </div>
          ):null}



          {item.type === 'Scene'?(              
            <div style={{color:`#FFF`,maxWidth:`100%`,width:`auto`,borderRadius: `14px`,padding: `8px`,marginRop: `20px`}}>
                 ---- 分頁 ---- 
            </div>
          ):null}
          
          {item.type === 'Text' || item.type === 'Narrative' ?(
            <div style={{color:item.text._attributes.color,
                          maxWidth:`100%`,
                          backgroundColor: (item.type === 'Narrative')?'transparent':item._attributes.itemColor,
                          width:`auto`,
                          display:`inline-block`,
                          borderRadius: `14px`,
                          padding: `8px`,
                          marginRop: `20px`,
                          fontSize:TextFontSize,
                          fontWeight:TextFontWeight}}>             
              <span contentEditable='true' style={{whiteSpace: `pre-line`}}
                onInput={(e) => {
                  //this.props.item.text._text = e.currentTarget.textContent; 
                  this.props.item.text._text = e.currentTarget.innerText; //trying to get new line character                  
                }}
                onClick={(e) => {
                  if (this.props.item.isSelected)
                    e.stopPropagation();
                }}>
                {this.props.item.text._text}
              </span>
            </div>
            ):null}
        </StoryItemCard>
    )
  }
}